import { GetSellerOnboardingRequirementsResponse } from '@iwoca/lapi-client/edge';

export type ResolutionMethods = {
  bankWizard?: ResolutionMethod;
  documentUpload?: ResolutionMethod;
  manualBankDetailsVerification: ResolutionMethod;
};

export type ResolutionMethod =
  | {
      status: 'required' | 'pending' | 'error' | 'completed';
      errors: string[];
      type: string;
    }
  | undefined;

export function getBankDetailRequirements(
  requirements?: GetSellerOnboardingRequirementsResponse['data'],
) {
  if (!requirements) return;

  const verifiedBankDetailsLimitedCompany = requirements.find(
    (req) => req.requirement === 'verified_bank_details_limited_company',
  );

  const verifiedBankDetailsSoleTrader = requirements.find(
    (req) => req.requirement === 'verified_bank_details_sole_trader',
  );

  if (verifiedBankDetailsSoleTrader) {
    const manualBankDetailsVerification =
      verifiedBankDetailsSoleTrader?.resolution_methods.find(
        (resolution_method) =>
          resolution_method.type === 'manual_bank_details_verification',
      );

    const documentUpload =
      verifiedBankDetailsSoleTrader?.resolution_methods.find(
        (resolution_method) => resolution_method.type === 'document_upload',
      );

    return {
      manualBankDetailsVerification,
      documentUpload,
    };
  }

  const bankWizard = verifiedBankDetailsLimitedCompany?.resolution_methods.find(
    (resolution_method) => resolution_method.type === 'experian_bank_wizard',
  );

  const documentUpload =
    verifiedBankDetailsLimitedCompany?.resolution_methods.find(
      (resolution_method) => resolution_method.type === 'document_upload',
    );

  const manualBankDetailsVerification =
    verifiedBankDetailsLimitedCompany?.resolution_methods.find(
      (resolution_method) =>
        resolution_method.type === 'manual_bank_details_verification',
    );

  return {
    bankWizard,
    documentUpload,
    manualBankDetailsVerification,
  };
}
